import {
    AutocompleteOption,
    AutocompleteOptionsProps,
} from "components/Form/components/Autocomplete/Autocomplete";
import { Input } from "components/Form/components/Input/Input";
import { capitalizeFirstLetterRestLowercase } from "utils/utils";
import { FormComponentProps } from "../FormComponentProps";
import { ExtendedAutocomplete } from "./ExtendedAutocomplete";

const executionLocationLabels: Record<string, string> = {
    webhook_record: "Webhook",
    triggering_record: "Triggering record",
    flow_record: "Flow",
    plugin_resource: "Plugin",
};

export const ExtendedAutocompleteFormComponent = ({
    input,
    fieldProps,
    fieldAttr,
    meta,
}: FormComponentProps) => {
    const { options, defaultValue, specialValue, extendedAutocompleteOptions, ...restProps } =
        fieldProps;

    const label = executionLocationLabels[defaultValue] ?? defaultValue;

    const defaultLabelValue =
        defaultValue !== undefined
            ? {
                  value: defaultValue,
                  label: capitalizeFirstLetterRestLowercase(label).replace("_", " "),
              }
            : undefined;
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <ExtendedAutocomplete
                name={input.name}
                options={options}
                defaultValue={defaultLabelValue}
                value={input.value === "triggering_resource" ? "triggering_record" : input.value}
                specialValue={specialValue as AutocompleteOption}
                extendedAutocompleteOptions={
                    extendedAutocompleteOptions as AutocompleteOptionsProps
                }
                additionalProps={{ fieldWidth: 420, ...restProps, ...fieldAttr }}
                onChange={input.onChange}
            />
        </Input>
    );
};
